import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-contents" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_6 = { class: "form-text text-muted" };
const _hoisted_7 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_8 = {
    key: 0,
    class: "clearfix top10"
};
const _hoisted_9 = { class: "col-xs-12" };
const _hoisted_10 = { class: "clearfix top10" };
const _hoisted_11 = { class: "col-xs-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_b_button = _resolveComponent("b-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "form-details" }, [
            _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tAudit Log Settings\r\n\t\t\t\t")
            ])
        ], -1 /* CACHED */)),
        _cache[17] || (_cache[17] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clearfix" }, [
                    _createElementVNode("p", { class: "text-muted" }, "\r\n\t\t\t\t\t\tHow long Audit Log entries are kept. A company can set its own period on its\r\n\t\t\t\t\t\tSettings page; these are the defaults applied when it has not.\r\n\t\t\t\t\t")
                ], -1 /* CACHED */)),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[2] || (_cache[2] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tDefault retention for companies (days)\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createVNode(_component_b_form_input, {
                            type: "number",
                            modelValue: _ctx.model.defaultCompanyDaysToRetain,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.model.defaultCompanyDaysToRetain) = $event)),
                            modelModifiers: { number: true },
                            min: _ctx.model.minimumDaysToRetain,
                            max: _ctx.model.maximumDaysToRetain,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "min", "max", "disabled"]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("small", _hoisted_6, "\r\n\t\t\t\t\t\t\tApplied to any company that has not set its own period.\r\n\t\t\t\t\t\t\tBetween " + _toDisplayString(_ctx.model.minimumDaysToRetain) + " and " + _toDisplayString(_ctx.model.maximumDaysToRetain) + " days.\r\n\t\t\t\t\t\t", 1 /* TEXT */)
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_7, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tRetention for system-wide entries (days)\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createVNode(_component_b_form_input, {
                            type: "number",
                            modelValue: _ctx.model.applicationDaysToRetain,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.model.applicationDaysToRetain) = $event)),
                            modelModifiers: { number: true },
                            min: _ctx.model.minimumDaysToRetain,
                            max: _ctx.model.maximumDaysToRetain,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "min", "max", "disabled"]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _cache[8] || (_cache[8] = _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\t\tApplied to entries that belong to no company — alarm types, block types\r\n\t\t\t\t\t\t\tand other system-wide configuration.\r\n\t\t\t\t\t\t", -1 /* CACHED */))
                    ])
                ]),
                _cache[14] || (_cache[14] = _createTextVNode()),
                (_ctx.isReduction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_b_alert, {
                                variant: "warning",
                                "model-value": true
                            }, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("strong", null, "This shortens retention.", -1 /* CACHED */),
                                        _createTextVNode("\r\n\t\t\t\t\t\t\tEntries older than the new period become eligible for deletion the next time\r\n\t\t\t\t\t\t\tthe retention job runs. This cannot be undone once it has run.\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            disabled: _ctx.working || !_ctx.isValid,
                            onClick: _ctx.save
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("i", {
                                    class: _normalizeClass(["fa", _ctx.working ? 'fa-spinner fa-spin' : 'fa-save'])
                                }, null, 2 /* CLASS */),
                                _cache[11] || (_cache[11] = _createTextVNode("\r\n\t\t\t\t\t\t\tSave\r\n\t\t\t\t\t\t", -1 /* CACHED */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled", "onClick"])
                    ])
                ])
            ])
        ])
    ]));
}
